import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/components/img/pv_img_demo_good.png'
import _imports_1 from '@/components/img/pv_img_demo_bad.png'


const _withScopeId = n => (_pushScopeId("data-v-9d256380"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"overflow":"auto","height":"100%","display":"flex","flex-direction":"column"} }
const _hoisted_2 = { class: "guideTitle" }
const _hoisted_3 = { class: "guideDescription" }
const _hoisted_4 = { class: "stepTitle" }
const _hoisted_5 = { class: "guideStepDescription" }
const _hoisted_6 = { class: "locationList" }
const _hoisted_7 = { class: "guideStepDescription" }
const _hoisted_8 = { class: "stepTitle" }
const _hoisted_9 = { class: "guideStepDescription" }
const _hoisted_10 = { class: "guideStepDescription" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Vehicle Image Example"
}, null, -1))
const _hoisted_12 = { class: "guideStepDescription" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Vehicle Image Example"
}, null, -1))
const _hoisted_14 = { class: "stepTitle" }
const _hoisted_15 = { class: "guideStepDescription" }
const _hoisted_16 = {
  class: "guideStepDescription",
  style: {"margin-bottom":"2rem"}
}

import ReturnButton from '@/components/returnButton.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'StartGuide',
  setup(__props) {

const { t } = useI18n({
    inheritLocale: true,
    useScope: 'global',
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('plateEngineGuide.title')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('plateEngineGuide.description')), 1),
      _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(t)('plateEngineGuide.step1.title')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('plateEngineGuide.step1.description')), 1),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", null, _toDisplayString(_unref(t)('plateEngineGuide.step1.eu')), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(t)('plateEngineGuide.step1.na')), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(t)('plateEngineGuide.step1.ca')), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(t)('plateEngineGuide.step1.sa')), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(t)('plateEngineGuide.step1.other')), 1)
      ]),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('plateEngineGuide.step1.recognition')), 1),
      _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(t)('plateEngineGuide.step2.title')), 1),
      _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('plateEngineGuide.step2.description')), 1),
      _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('plateEngineGuide.step2.goodExample')), 1),
      _hoisted_11,
      _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('plateEngineGuide.step2.badExample')), 1),
      _hoisted_13,
      _createElementVNode("h4", _hoisted_14, _toDisplayString(_unref(t)('plateEngineGuide.step3.title')), 1),
      _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)('plateEngineGuide.step3.description')), 1),
      _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)('plateEngineGuide.step3.seeLater')), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(ReturnButton)
    ])
  ], 64))
}
}

})